let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hkeZT")).then(() => parcelRequire('h7Z1H'));